/**
 * DATA TO CHART FILTER
 * Take your colleection as an input parameter, set custom field to map X & Y axis.
 * Return an object with { x: [1,2,3], y: [1,2,3] }
 */

export default {
  methods: {
    dataTochart (data, xItem, yItem) {
      let xValues = []
      let yValues = []
      data.forEach(element => {
        xValues.push(element[xItem])
        yValues.push(element[yItem])
      })
      return { x: xValues, y: yValues }
    },
    logsToBarChartByGroup(logs) {
      //--
      const stats = {
        operator: [0,0,0,0],
        maintenance: [0,0,0,0],
        responsable: [0,0,0,0],
        manager: [0,0,0,0]
      }

      const zones = ['Zone1', 'Zone2', 'Zone3', 'idle'];
      //--
      const operatorIdGroup = this.$store.getters.operatorIdGroup;
      logs.forEach( log => {
        const timeConsumed = log[3] - log[2];
        if(stats[operatorIdGroup[log[1]]] !== undefined) {
          stats[operatorIdGroup[log[1]]][zones.indexOf(log[0])] += timeConsumed;
        }
      })
      stats.responsable = stats.manager; //--> ! DIRTY QUICK FIX !
      return {cat: zones, data: stats};
    },
    logsToBarChartByGroupFaker(logs, ofName) {
      //-- GET LOGS FOR THIS MO
      const logsForThisOf = logs.filter(log => log[4] === ofName);
      //-- ZONE FOR THIS MO & GET BEACON ID RECORDED FOR THIS MO
      let zonesForThisOf = [];
      let beaconRecorded = [];
      logsForThisOf.forEach( log => {
        zonesForThisOf.push(log[0]);
        beaconRecorded.push(log[1]);
      });
      zonesForThisOf = Array.from(new Set(zonesForThisOf));
      beaconRecorded = Array.from(new Set(beaconRecorded));
      //--
      const stats = {}
      const zones = zonesForThisOf;
      stats.operator = Array.from({length: zones.length}, () => 0);
      stats.maintenance = Array.from({length: zones.length}, () => 0);
      stats.responsable = Array.from({length: zones.length}, () => 0);
      stats.manager = Array.from({length: zones.length}, () => 0);
      //--
      const operatorIdGroup = this.$store.getters.operatorBeaconIdGroup;
      logsForThisOf.forEach( log => {
        let timeConsumed = 0;
        if(String(log[3]).length < 13) { 
          timeConsumed = log[3]*1000 - log[2]*1000;
        } else {
          timeConsumed = log[3] - log[2];
        }
        if(stats[operatorIdGroup[log[1]]] !== undefined) {
          stats[operatorIdGroup[log[1]]][zones.indexOf(log[0])] += timeConsumed;
        }
      })
      stats.responsable = stats.manager; //--> ! DIRTY QUICK FIX !
      return {cat: zones, data: stats};
    }
  }
}
